import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import type { OptionTagProps as Props } from './types';
import { OptionTagContent } from '../option-tag-content';

export const OptionTag = memo(
  ({
    className,
    label,
    onDelete,
    multiple,
    extraDeleteAction,
    logoUrl,
  }: Props) => {
    if (!label) return null;

    const handleDelete = (e: React.BaseSyntheticEvent) => {
      e.stopPropagation();
      onDelete?.(e);
      extraDeleteAction?.();
    };
    return (
      <Styled.Wrapper
        className={classnames('OptionTag', className)}
        label={<OptionTagContent logoSrc={logoUrl ?? ''} title={label} />}
        color="primary"
        variant="soft"
        size="medium"
        onDelete={handleDelete}
        shape="rounded"
      />
    );
  }
);

OptionTag.displayName = 'OptionTag';
